import { render } from "./scrollBtn.vue?vue&type=template&id=8e834076&scoped=true"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=8e834076&scoped=true&lang=scss"

import exportComponent from "/builds/development-team/front-end/acgnn-sports/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e834076"]])

export default __exports__